export default "__VITE_ASSET__1472d55f__"